export default "__VITE_ASSET__6cTes2st__"